module.exports = __webpack_public_path__ + "img/soft_10.5a87512d.png";